// extracted by css-extract-rspack-plugin
export default {"cls1":"Typeahead-cls1_xKQ","cls2":"Typeahead-cls2_Q38 Typeahead-cls1_xKQ"};